export function initialize(id) {
  const input = document.querySelector(`[data-suggest='${id}']`)
  input.addEventListener("focus", (ev) => showList(ev, true))
  input.addEventListener("click", (ev) => showList(ev, true)) 
  input.addEventListener("input", (ev) => { showList(ev, true); filterItems(ev.target.value) })

  const suggest_container = input.closest(".suggest-container")
  
  const list_container = suggest_container.querySelector(`[data-suggest='suggest-list']`)
  const list_items = suggest_container.querySelectorAll(`[data-suggest='suggest-item']`)
  list_items.forEach((i) => i.addEventListener("click", (ev) => clickItem(ev.target)))
  document.addEventListener("click", (ev) => showList(ev, false))
  
  const empty_item = suggest_container.querySelector(`[data-suggest='suggest-item-empty']`)
  const select = suggest_container.querySelector(`[data-suggest='suggest-select']`).querySelector("select")
  
  if(select.selectedOptions.length === 1 && select.selectedOptions[0].value !== "") {
    input.value = select.selectedOptions[0].textContent
  }
  
  function showList(ev, show) {
    filterItems(input.value)
    list_container.style.display = show ? "block" : "none"
    ev.stopPropagation()
  }
  
  function filterItems(val) {
    list_items.forEach((item) => {
      if(val === "" || item.textContent.includes(val)) {
        item.style.display = "list-item"
      } else {
        item.style.display = "none"
      }
    })
    if(Array.from(list_items).map((i) => i.style.display).every((display) => display === "none")) {
      empty_item.style.display = "list-item"
    } else {
      empty_item.style.display = "none"
    }
  }
  
  function clickItem(target) {
    input.value = target.textContent
    select.querySelectorAll("option").forEach((i) => i.removeAttribute("selected"))
    select.querySelector(`option[value="${target.dataset.suggestValue}"]`).setAttribute("selected", "selected")
  }
}
